// Webpack Imports
import * as bootstrap from 'bootstrap';

if(!$('body').hasClass('.trp-editor-body')) {
    ( function () {
        'use strict';

        // Focus input if Searchform is empty
        [].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
            el.addEventListener( 'submit', function ( e ) {
                var search = el.querySelector( 'input' );
                if ( search.value.length < 1 ) {
                    e.preventDefault();
                    search.focus();
                }
            } );
        } );

        // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
        var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
        var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
            return new bootstrap.Popover( popoverTriggerEl, {
                trigger: 'focus',
            } );
        } );
    } )();

    // Body class add on dom loaded
    document.addEventListener("DOMContentLoaded", function() {
        setTimeout(function(){
        // Select 2
        if($('select').length && $('body').hasClass('page-template-contact-sales2')) {
            $('select').select2({
                placeholder: "Select...",
                allowClear: false
            });

            $('select[name="company-size"]').select2({
                minimumResultsForSearch: -1
            });
        }
            document.body.classList.add('dom-loaded');
        },200);


        const forbiddenZone =
            Intl.DateTimeFormat()
                .resolvedOptions()
                .timeZone.indexOf("Asia/Calcutta") == 0 ||
            Intl.DateTimeFormat()
                .resolvedOptions()
                .timeZone.indexOf("Asia/Karachi") == 0 ||
            Intl.DateTimeFormat()
                .resolvedOptions()
                .timeZone.indexOf("Asia/Dhaka") == 0;
        if (forbiddenZone) {
            document.querySelector('input[type="submit"]').value = "Send";
            if($('#sales-schedule-demo')) {
                document.getElementById("sales-schedule-demo").style.display = "none";
            }
        } else {
            if($('#sales-get-touch').length) {
                document.getElementById("sales-get-touch").style.display = "none";
            }
        }

        if(document.location.pathname.includes('/contact/sales')){
            document.addEventListener(
                "wpcf7mailsent",
                function (event) {
                    const data = getFormValues();
                    const isValid = !!data;
                    if (isValid) {
                        sendData(data, !forbiddenZone); // our custom submit
                    }
                },
                false
            );
        }
        

    });
	
	// Utility function to safely get the value of an input element
	function getInputValue(selector) {
		var element = document.querySelector(selector);
		return element ? element.value : '';
	}
	
	// Utility to get the first textarea value
	function getTextareaValue() {
		var textarea = document.querySelector('textarea');
		return textarea ? textarea.value : '';
	}
	
	// Utility to get the first file input value
	function getFileValue() {
		var fileInput = document.querySelector('[type=file]');
		return fileInput ? fileInput.value : null;
	}
	
	// Main function to collect form values
	function getFormValues() {
		try {
			var yourName 	= getInputValue('[name="your-name"]');
			var yourEmail 	= getInputValue('[name="your-email"]');
			var yourCompany = getInputValue('[name="your-company"]');
			var yourRole 	= getInputValue('[name="your-role"]');
			var companySize = getInputValue('[name="company-size"]');
			var country 	= getInputValue('[name="country"]');
			var textarea210 = getTextareaValue();
			var file443 	= getFileValue();
	
			return {
				name: yourName,
				emailAddress: yourEmail,
				companyName: yourCompany,
				title: yourRole,
				companyHeadcount: companySize,
				country: country,
				description: textarea210,
				fileAttached: !!file443,
				tag: "sales-form-bundle",
			};

		} catch (e) {
			console.error("Form parsing failed!!!");
			console.error(e);

			return null;
		}
	}
	

    function sendData(data, redirectCalendly) {

        fetch('https://crm-api.cake.com/sales/contact', {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            },
        }).finally(() => redirectToCalendly(data.companyHeadcount, redirectCalendly));

    }

    function redirectToCalendly(size, redirectCalendly) {
        if (!redirectCalendly) return;

        const CAKE_HELP_URL_SMALL = "https://calendly.com/cake-com/cake-com-bundle-demo-30min";
        const CAKE_HELP_URL_LARGE = "https://calendly.com/cake-com/bundle-demo";

        let url = "";

        url = (size === "1-50") ? CAKE_HELP_URL_SMALL : CAKE_HELP_URL_LARGE;

        if (url) {
            window.location.href = url;
        }
    }

    // Custom CTA for submit field
    $(document).ready(function() {
        const $body = $('body');
        const $submitButtonWrapper = '<div class="contact-form-button-wrapper"></div>';

        if ($body.hasClass('page-template-contact-sales')
            || $body.hasClass('page-template-delete-form')
            || $body.hasClass('page-template-complaint')
            || $body.hasClass('page-template-request-soc2') ) {
            $('.contact-sales-wrap__form input[type="submit"]').wrap($submitButtonWrapper);

        } else if ($body.hasClass('page-template-contact')) {
            const $contactPageSubmit = $('.contact-page-form input[type="submit"]');
            $contactPageSubmit.attr('value', 'Send message');
            $contactPageSubmit.wrap($submitButtonWrapper);
        }
    });

    // Search trigger mobile
    if ($(window).width() < 991 && $('form.search-form').length) {
        $('form.search-form').find('input.form-control').attr('placeholder', 'Search the Help Center');
    }

    // $('.mobile-search-trigger').on('click', function(e) {
    //     let currentTarget = $(e.currentTarget);

    //     if(currentTarget.hasClass('visible')) {
    //         currentTarget.removeClass('visible');
    //         currentTarget.parent('.search-with-contact').find('.input-group').removeClass('visible');
    //     }

    //     else {
    //         currentTarget.addClass('visible');
    //         currentTarget.parent('.search-with-contact').find('.input-group').addClass('visible');
    //     }
    // });

    // $('.mobile-search-trigger-close').on('click', function(e) {
    //     let currentTargetClose = $(e.currentTarget);
    //     currentTargetClose.closest('.search-with-contact').find('.input-group').removeClass('visible');
    //     currentTargetClose.closest('.search-with-contact').find('.mobile-search-trigger').removeClass('visible');
    // });

    // Category menu
    if($('.post-header').find('.primary-menu-wrapper').length) {
        $('.primary-menu-wrapper').find('.dropdown-menu').each(function() {

        });
    }

    // Detect OS
    function checkOperatingSystem() {
        var  userAgent = navigator.userAgent || navigator.vendor || window.opera;

        //Check mobile device is Android
        if (/android/i.test(userAgent)) {
            $('body').addClass('mobile');
        }

        //Check mobile device is IOS
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            $('body').addClass('mobile');
        }

        //Check device os is MAC (For Laptop and PC)
        if (navigator.appVersion.indexOf("Mac")!=-1) {
            $('body').addClass('mac-os');
        }  
    }

    checkOperatingSystem();
}


const asideBarLists = document.querySelectorAll('.aside-bar-list');
const accTOCbody = document.getElementById('accordion-toc-body');

asideBarLists.forEach((list) => {
    const asideBarLinks = list.querySelectorAll('li a');
    if (asideBarLinks) {
        asideBarLinks.forEach((item) => {
            item.addEventListener('click', function() {
                asideBarLinks.forEach((item) => {
                    item.classList.remove('active');
                });
                item.classList.add('active');
                accTOCbody.classList.remove('show');
            });
        });
    }
});
// Close the TOC accordion on click anywhere
document.addEventListener('click', function() {
    if (accTOCbody) {
        accTOCbody.classList.remove('show');
    }
});

// Header search form
document.addEventListener("DOMContentLoaded", () => {
    const searchIcons = document.querySelectorAll('.search-trigger');
    const headerSearchInputs = document.querySelectorAll('.mobile-search');
    const homePageSearchInput = document.querySelector('.home-page-search-input');

    if (searchIcons.length && headerSearchInputs.length) {
        searchIcons.forEach((icon) => {
            icon.addEventListener('click', () => {
                headerSearchInputs.forEach((input) => input.classList.toggle('show'));

                const mobileSearchTrigger = icon.classList.contains('mobile-search-trigger');
                if (mobileSearchTrigger) {
                    icon.classList.toggle('active');
                }
            });
        });
    }

    if (homePageSearchInput && window.innerWidth < 991) {
        homePageSearchInput.placeholder = 'Search the Help Center';
    }
});